module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-view",
    class: _vm.page.css_class
  }, [_c('div', {
    staticClass: "page-content",
    attrs: {
      "id": "slices"
    }
  }, _vm._l((_vm.slicesToDisplay), function(slice, sliceKey) {
    return (slice.visible) ? _c('div', {
      style: (slice.css_style)
    }, [(slice.css_class == 'video') ? _c('div', {
      staticClass: "video-container",
      attrs: {
        "id": 'slice_' + _vm.page.slug + '_' + sliceKey
      }
    }, [_c('div', {
      class: 'slice ' + slice.css_class,
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    })]) : _vm._e(), _vm._v(" "), (slice.css_class != 'video') ? _c('div', {
      class: 'slice ' + slice.css_class,
      attrs: {
        "id": 'slice_' + _vm.page.slug + '_' + sliceKey
      },
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    }) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), (_vm.page.listed) ? _c('div', {
    attrs: {
      "id": "nav-page"
    }
  }, [(_vm.page.listed) ? _c('div', {
    attrs: {
      "id": "prev-next"
    }
  }, [(_vm.prevPage) ? _c('router-link', {
    staticClass: "thumb prev",
    attrs: {
      "to": '/work/' + _vm.prevPage.slug
    }
  }, _vm._l((_vm.prevPage.slices), function(slice) {
    return (slice.index < 3) ? _c('div', {
      class: slice.css_class
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    })]) : _vm._e()
  })) : _vm._e(), _vm._v(" "), (_vm.nextPage) ? _c('router-link', {
    staticClass: "thumb next",
    attrs: {
      "to": '/work/' + _vm.nextPage.slug
    }
  }, _vm._l((_vm.nextPage.slices), function(slice) {
    return (slice.index < 3) ? _c('div', {
      class: slice.css_class
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(slice.content)
      }
    })]) : _vm._e()
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.page.slug == 'home') ? _c('router-link', {
    attrs: {
      "id": "push-home",
      "to": '/work'
    }
  }, [_c('p', [_vm._v("Discover the pieces")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a82feac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/front/PageView.vue
// module id = 262
// module chunks = 1